// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popup-map{max-width:100%;height:auto;width:100%}\n", "",{"version":3,"sources":["webpack://src/components/MapContainer.scss"],"names":[],"mappings":"AAAA,WACI,cAAe,CACf,WAAY,CACZ,UAAW","sourcesContent":[".popup-map {\r\n    max-width: 100%;\r\n    height: auto;\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
